// ══════════════════════════════════════════════════════
// TRADING PLATFORM — Premium Light Theme v5
// ══════════════════════════════════════════════════════

export const theme = {
  // Canvas
  bg: "#F8F8F6",
  white: "#FFFFFF",
  frost: "rgba(255,255,255,0.88)",
  tint: "rgba(0,0,0,0.024)",
  hover: "rgba(0,0,0,0.032)",
  active: "rgba(0,0,0,0.055)",
  divider: "rgba(0,0,0,0.06)",
  border: "rgba(0,0,0,0.08)",
  borderStrong: "rgba(0,0,0,0.12)",

  // Shadows
  shadow1: "0 1px 2px rgba(0,0,0,0.04), 0 0 0 1px rgba(0,0,0,0.03)",
  shadow2: "0 2px 8px rgba(0,0,0,0.05), 0 0 0 1px rgba(0,0,0,0.04)",
  shadow3: "0 8px 24px rgba(0,0,0,0.06), 0 0 0 1px rgba(0,0,0,0.03)",
  shadowGreen: "0 2px 12px rgba(22,163,74,0.10), 0 0 0 1px rgba(22,163,74,0.08)",
  shadowRed: "0 2px 12px rgba(220,38,38,0.08), 0 0 0 1px rgba(220,38,38,0.06)",

  // Text
  text: "#0F172A",
  text2: "#475569",
  text3: "#94A3B8",
  text4: "#CBD5E1",
  text5: "#E2E8F0",

  // Accent
  blue: "#2563EB",
  blueLight: "#EFF6FF",
  blueText: "#1D4ED8",

  // Semantic
  green: "#16A34A",
  greenLight: "#F0FDF4",
  greenLight2: "rgba(22,163,74,0.07)",
  greenText: "#15803D",
  greenBright: "#22C55E",
  red: "#DC2626",
  redLight: "#FEF2F2",
  redLight2: "rgba(220,38,38,0.05)",
  redText: "#B91C1C",
  amber: "#D97706",
  amberLight: "#FFFBEB",
  amberText: "#92400E",
  purple: "#7C3AED",
  purpleLight: "#F5F3FF",
  purpleText: "#6D28D9",
  cyan: "#0891B2",
  cyanLight: "#ECFEFF",
  cyanText: "#0E7490",
};

export const fonts = {
  body: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
  mono: "'JetBrains Mono', 'SF Mono', monospace",
  serif: "'Plus Jakarta Sans', -apple-system, sans-serif",
};

export const radius = { sm: 8, md: 12, lg: 16, xl: 20, full: 9999 };
